// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/badge-check.js';

import { paths } from '../generated/badge-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('badge-check', Original, paths);
